import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { db } from '../firebase';
import { collection, addDoc } from "firebase/firestore";
import '../css/AdmissionForm.css';


const AdmissionForm = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("inquiry");
  const [formData, setFormData] = useState({
    studentName: '',
    grade: '',
    parentName: '',
    phone: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [selectedClass, setSelectedClass] = useState("Nursery");

const feeData = {
  Nursery: {
    registration: 500,
    admission: 8000,
    annual: 6500,
    tuition: 2500,
    total: 45000,
  },

  "L.K.G.": {
    registration: 500,
    admission: 9000,
    annual: 7000,
    tuition: 2800,
    total: 49000,
  },

  "U.K.G.": {
    registration: 500,
    admission: 9500,
    annual: 7000,
    tuition: 3000,
    total: 51000,
  },

  "Class 1": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
  "Class 2": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
  "Class 3": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
  "Class 4": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
  "Class 5": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
  "Class 6": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
  "Class 7": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
  "Class 8": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
  "Class 9": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
  "Class 10": {
    registration: 500,
    admission: 10000,
    annual: 7500,
    tuition: 3200,
    total: 56000,
  },
};
useEffect(() => {
  if (location.hash === "#fees") {
    setActiveTab("fees");
  } else {
    setActiveTab("inquiry");
  }
}, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Firebase Firestore me "admissions" collection me save hoga
      await addDoc(collection(db, "admissions"), {
        studentName: formData.studentName,
        grade: formData.grade,
        parentName: formData.parentName,
        phone: formData.phone,
        message: formData.message,
        submittedAt: new Date()
      });

      alert("Inquiry Sent Successfully! We will contact you soon.");
      // Form fields clean karne ke liye reset state
      setFormData({ studentName: '', grade: '', parentName: '', phone: '', message: '' });
    } catch (error) {
      alert("Error sending inquiry: " + error.message);
    }
    setLoading(false);
  };

  return (
    <div className="admission-container">
      <div className="admission-banner">
        <h1>Admission Open 2026-27</h1>
        <p>Start your child's journey with Sahara Public Secondary School</p>
      </div>
      <div className="admission-tabs">
  <button
    className={activeTab === "inquiry" ? "active" : ""}
    onClick={() => setActiveTab("inquiry")}
  >
    Inquiry Form
  </button>

  <button
    className={activeTab === "fees" ? "active" : ""}
    onClick={() => setActiveTab("fees")}
  >
    Fee Structure
  </button>
</div>

   
  
{activeTab === "inquiry" && (
<div className="admission-wrapper">
        {/* Left Side: Form */}
        <div className="admission-form-section">
          <h2>Inquiry Form</h2>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Student Full Name</label>
              <input 
                type="text" 
                name="studentName"
                required 
                placeholder="Enter student name" 
                value={formData.studentName}
                onChange={handleChange}
              />
            </div>
           

            <div className="input-row">
              <div className="input-group">
                <label>Applying for Grade</label>
                <select 
                  name="grade"
                  required 
                  value={formData.grade}
                  onChange={handleChange}
                >
                  <option value="">Select Grade</option>
                  <option value="Nursery">Nursery</option>
                  <option value="L.K.G.">L.K.G.</option>
                  <option value="U.K.G.">U.K.G.</option>
                  <option value="Class 1">Class 1</option>
                  <option value="Class 2">Class 2</option>
                  <option value="Class 3">Class 3</option>
                  <option value="Class 4">Class 4</option>
                  <option value="Class 5">Class 5</option>
                  <option value="Class 6">Class 6</option>
                  <option value="Class 7">Class 7</option>
                  <option value="Class 8">Class 8</option>
                  <option value="Class 9">Class 9</option>
                  <option value="Class 10">Class 10</option>
                  <option value="Class 11">Class 11</option>
                  <option value="Automobile">Automobile</option>
                  <option value="Hotel Management">Hotel Management</option>
                </select>
              </div>
              <div className="input-group">
                <label>Parent's Phone Number</label>
                <input 
                  type="tel" 
                  name="phone"
                  required 
                  placeholder="Contact number" 
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div>
           
            
  

            <div className="input-group">
              <label>Parent/Guardian Name</label>
              <input 
                type="text" 
                name="parentName"
                required 
                placeholder="Enter parent name" 
                value={formData.parentName}
                onChange={handleChange}
              />
            </div>

            <div className="input-group">
              <label>Message/Remarks (Optional)</label>
              <textarea 
                name="message"
                rows="4" 
                placeholder="Any specific requirements..."
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <button type="submit" className="admission-submit-btn" disabled={loading}>
              {loading ? "SENDING..." : "SUBMIT INQUIRY"}
            </button>
          </form>
        </div>

        {/* Right Side: Contact Info/Guidelines */}
        <div className="admission-info-section">
          <div className="info-card">
            <h3>Admission Helpline</h3>
            <p>📞 +977-9847040404</p>
            <p>📧 info@sahara.edu.np</p>
          </div>
          <div className="info-card secondary">
            <h3>Documents Required</h3>
            <ul>
              <li>Birth Certificate (Copy)</li>
              <li>Passport Size Photos (2)</li>
              <li>Previous School Report Card</li>
              <li>Transfer Certificate (Original)</li>
            </ul>
          </div>
        </div>
      </div>
   
)}

  {activeTab === "fees" && (

<div className="fee-structure">

<h2>School Fee Structure</h2>

<div className="fee-class-tabs">

{Object.keys(feeData).map((cls)=>(

<button
key={cls}
className={selectedClass===cls ? "active" : ""}
onClick={()=>setSelectedClass(cls)}
>

{cls}

</button>

))}

</div>

<div className="fee-grid">

<div className="fee-card">
<h3>Registration Fee</h3>
<h2>₹{feeData[selectedClass].registration}</h2>
</div>

<div className="fee-card">
<h3>Admission Fee</h3>
<h2>₹{feeData[selectedClass].admission}</h2>
</div>

<div className="fee-card">
<h3>Annual Fee</h3>
<h2>₹{feeData[selectedClass].annual}</h2>
</div>

<div className="fee-card">
<h3>Monthly Tuition Fee</h3>
<h2>₹{feeData[selectedClass].tuition}</h2>
</div>

</div>

<div className="fee-total">

<h2>Total Fee</h2>

<h1>₹{feeData[selectedClass].total}</h1>

</div>

</div>


)}

</div>
  );
};

export default AdmissionForm;